import { Hauler } from '@rcp/types';
import { RestSlice } from '../../../../redux/rest.slice';
import { Resource, localizationService } from 'src/services';

export const haulersSlice = new RestSlice<Hauler>(
	localizationService.getLocalizedString('haulers.haulers'),
	Resource.Haulers
);
export const haulersRestSliceReducer = haulersSlice.rests.reducer;
